import styled from 'styled-components';
import tw from 'twin.macro';

import type { SourceIconType } from '@/atoms/Icon';
import { Icon } from '@/atoms/Icon';
import { Badge } from '@/components/Atoms/Badge/Badge';
import ChatIcon from '@/icons/chat.svg?react';
import ChatFillIcon from '@/icons/chat-fill.svg?react';

export const CommentActionIcon = ({
  count,
  fill,
  disabled = false,
}: CommentIconType) => {
  return (
    <Badge
      badgeContent={count}
      variant='standard'
      color='primary'
      size='small'
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
    >
      {fill ? (
        <StyledChatFillIcon aria-hidden />
      ) : (
        <StyledChatIcon disabled={disabled} aria-hidden />
      )}
    </Badge>
  );
};

export const CommentTabIcon = ({ count, fill }: CommentIconType) => {
  return (
    <Icon>
      <CommentActionIcon count={count} fill={fill} />
    </Icon>
  );
};

const StyledChatFillIcon = styled(ChatFillIcon)`
  ${tw`!fill-emerald-900`}
`;

const StyledChatIcon = styled(ChatIcon)<StyledChatIconProps>`
  ${({ disabled = false }) =>
    disabled ? tw`!fill-gray-400` : tw`!fill-gray-700`}
`;

type CommentIconType = {
  count?: number;
  fill?: boolean;
  disabled?: boolean;
};

type CommentTabIcon = CommentIconType & {
  size?: Pick<SourceIconType, 'size'>;
};

type StyledChatIconProps = {
  disabled?: boolean;
};
